import { Component, HostListener, OnInit } from '@angular/core';
import {
  AnnouncementService,
  MarketplaceExtendedQuery,
  MarketplaceItemExtended,
  MarketplaceService,
  ProcessProviderId,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom, map, Observable } from 'rxjs';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';
import { Populations } from 'src/app/shared/utilities/populations';

enum RewardWidth {
  Destop = 302,
  Tablet = 194,
  Mobile = 165,
}
@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  campaignOffersList = [];
  screenType = ScreenType;
  population = Populations;
  marketplaceItems$: Observable<MarketplaceItemExtended[] | undefined>;
  rewardMarketplaceItems$: Observable<MarketplaceItemExtended[] | undefined>;
  rewardsWidth: number | string;
  customOptions: OwlOptions = {
    autoHeight: true,
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 2 },
      740: { items: 2 },
      900: { items: 3 },
    },
    dots: true,
  };
  constructor(
    private announcementService: AnnouncementService,
    private marketplaceExtendedQuery: MarketplaceExtendedQuery,
    private marketplaceService: MarketplaceService
  ) {}

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.setRewardsWidth(event?.target.screen.width);
  }

  ngOnInit() {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.fetchFavouriteEventItems();
    this.fetchFavouriteMarketplaceItems();
    this.setRewardsWidth(window.screen.width);
  }

  onCampaignOfferListChange(e: any) {
    this.campaignOffersList = e?.CampaignsAndEntitlements || [];
  }

  fetchFavouriteEventItems() {
    let ProcessProviderId: ProcessProviderId[] = [3];
    this.marketplaceItems$ = this.marketplaceExtendedQuery.selectExtendedMarketplaceItemsOfType(...ProcessProviderId).pipe(
      map((items) => {
        return items?.filter((item) => item.Favourite);
      })
    );
  }

  fetchFavouriteMarketplaceItems() {
    let ProcessProviderId: ProcessProviderId[] = [0, 1, 2];
    this.rewardMarketplaceItems$ = this.marketplaceExtendedQuery.selectExtendedMarketplaceItemsOfType(...ProcessProviderId).pipe(
      map((items) => {
        return items?.filter((item) => item.Favourite);
      })
    );
  }

  setRewardsWidth(screenSize: number) {
    if (screenSize >= 992) this.rewardsWidth = RewardWidth.Destop;
    if (screenSize < 992 && screenSize >= 425) this.rewardsWidth = RewardWidth.Tablet;
    if (screenSize < 425) this.rewardsWidth = RewardWidth.Mobile;
  }
}
